import PaypalMethod from './paypal-method';

export default PaypalMethod;
